import { ZodiacVirgoIcon } from './ZodiacVirgoIcon';

/**
 * author: Michael Richins
 * id 41D13BD9-7CB3-4015-A845-485B9915FA65
 * name zodiac-virgo
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zodiac-virgo.svg
 * tags
 */
export const HoroscopeVirgoIcon = ZodiacVirgoIcon;
export default HoroscopeVirgoIcon